import React, { useContext, useState } from "react";
import { DataContext } from "../contexts/DataContext";
import styled from "styled-components";
import MobileNet from "./MobileNet";
import Login from "./Login";
import ConnectionBanner from "./ConnectionBanner";

const Main = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text};
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  /* Clear the phone's notch / camera cutout on the top edge. */
  padding-top: max(env(safe-area-inset-top, 0px), 0.75em);
  box-sizing: border-box;
`;
const Notice = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4em;
  font-weight: 100;
`;

export default function CountEntry({ HandleThemeChange }) {
  const { data, addFishCount } = useContext(DataContext);
  const [peg, setPeg] = useState(() => {
    const stored = parseInt(sessionStorage.getItem("fish_count_peg"), 10);
    return sessionStorage.getItem("fish_count_auth") === "1" && stored
      ? stored
      : null;
  });

  if (!peg) {
    return (
      <Login
        onSuccess={(loggedInPeg) => {
          sessionStorage.setItem("fish_count_auth", "1");
          sessionStorage.setItem("fish_count_peg", String(loggedInPeg));
          setPeg(loggedInPeg);
        }}
      />
    );
  }

  function logout() {
    sessionStorage.removeItem("fish_count_auth");
    sessionStorage.removeItem("fish_count_peg");
    setPeg(null);
  }

  const pegData = data.data.find((p) => p.number === peg);

  return (
    <Main>
      <ConnectionBanner />
      {!pegData ? (
        <Notice>Loading peg {peg}…</Notice>
      ) : (
        <MobileNet
          mode="count"
          backLabel="Log Out"
          onBack={logout}
          HandleThemeChange={HandleThemeChange}
          data={pegData}
          addFishCount={(number, total, weighInNumber) => {
            addFishCount(number, total, weighInNumber);
          }}
        />
      )}
    </Main>
  );
}
